import { clsx } from 'clsx'
import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { IconCaretUp } from '@redteclab/icons'

type AdvertisingFlyoutBannerButtonProps = {
  className?: string
  onClick?: () => void
}

export const AdvertisingFlyoutBannerButton: FC<
  AdvertisingFlyoutBannerButtonProps
> = ({ className, onClick }) => {
  const buttonClasses = clsx(
    'flex items-center whitespace-nowrap rounded-t-3xl bg-light-brand-high px-6 text-s text-dark-primary-max desktop:py-3',
    className,
  )
  const intl = useIntl()

  return (
    <button className={buttonClasses} onClick={onClick} type="button">
      <IconCaretUp className="mr-1.5 size-8 fill-dark-primary-max" />

      <span className="desktop:inline">
        {intl.formatMessage({ id: 'advertisingFlyoutBanner.buttonText' })}
      </span>
    </button>
  )
}
